"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokensRequestFailure = exports.getTokensRequestSuccess = exports.getTokensRequestLoading = exports.resetTokensRequest = exports.getTokensRequest = exports.getServiceIdentitiesRequestFailure = exports.getServiceIdentitiesRequestSuccess = exports.getServiceIdentitiesRequestLoading = exports.resetServiceIdentitiesRequest = exports.getServiceIdentitiesRequest = exports.getTagMembersRequestFailure = exports.getTagMembersRequestSuccess = exports.getTagMembersRequestLoading = exports.resetTagMembersRequest = exports.getTagMembersRequest = exports.getGroupsRequestFailure = exports.getGroupsRequestSuccess = exports.getGroupsRequestLoading = exports.resetGroupsRequest = exports.getGroupsRequest = exports.getUsersRequestFailure = exports.getUsersRequestSuccess = exports.getUsersRequestLoading = exports.resetUsersRequest = exports.getUsersRequest = void 0;

var _constants = require("./constants");

var getUsersRequest = function getUsersRequest() {
  return {
    type: _constants.UsersType.USERS_REQUEST
  };
};

exports.getUsersRequest = getUsersRequest;

var resetUsersRequest = function resetUsersRequest() {
  return {
    type: _constants.UsersType.USERS_RESET
  };
};

exports.resetUsersRequest = resetUsersRequest;

var getUsersRequestLoading = function getUsersRequestLoading() {
  return {
    type: _constants.UsersType.USERS_LOADING
  };
};

exports.getUsersRequestLoading = getUsersRequestLoading;

var getUsersRequestSuccess = function getUsersRequestSuccess(payload) {
  return {
    type: _constants.UsersType.USERS_SUCCESS,
    payload: payload
  };
};

exports.getUsersRequestSuccess = getUsersRequestSuccess;

var getUsersRequestFailure = function getUsersRequestFailure(reason) {
  return {
    type: _constants.UsersType.USERS_FAILURE,
    payload: reason
  };
};

exports.getUsersRequestFailure = getUsersRequestFailure;

var getGroupsRequest = function getGroupsRequest() {
  return {
    type: _constants.GroupsType.GROUPS_REQUEST
  };
};

exports.getGroupsRequest = getGroupsRequest;

var resetGroupsRequest = function resetGroupsRequest() {
  return {
    type: _constants.GroupsType.GROUPS_RESET
  };
};

exports.resetGroupsRequest = resetGroupsRequest;

var getGroupsRequestLoading = function getGroupsRequestLoading() {
  return {
    type: _constants.GroupsType.GROUPS_LOADING
  };
};

exports.getGroupsRequestLoading = getGroupsRequestLoading;

var getGroupsRequestSuccess = function getGroupsRequestSuccess(payload) {
  return {
    type: _constants.GroupsType.GROUPS_SUCCESS,
    payload: payload
  };
};

exports.getGroupsRequestSuccess = getGroupsRequestSuccess;

var getGroupsRequestFailure = function getGroupsRequestFailure(reason) {
  return {
    type: _constants.GroupsType.GROUPS_FAILURE,
    payload: reason
  };
};

exports.getGroupsRequestFailure = getGroupsRequestFailure;

var getTagMembersRequest = function getTagMembersRequest(url, params) {
  return {
    type: _constants.TagMembersType.TAG_MEMBERS_REQUEST,
    payload: {
      url: url,
      params: params
    }
  };
};

exports.getTagMembersRequest = getTagMembersRequest;

var resetTagMembersRequest = function resetTagMembersRequest() {
  return {
    type: _constants.TagMembersType.TAG_MEMBERS_RESET
  };
};

exports.resetTagMembersRequest = resetTagMembersRequest;

var getTagMembersRequestLoading = function getTagMembersRequestLoading() {
  return {
    type: _constants.TagMembersType.TAG_MEMBERS_LOADING
  };
};

exports.getTagMembersRequestLoading = getTagMembersRequestLoading;

var getTagMembersRequestSuccess = function getTagMembersRequestSuccess(payload) {
  return {
    type: _constants.TagMembersType.TAG_MEMBERS_SUCCESS,
    payload: payload
  };
};

exports.getTagMembersRequestSuccess = getTagMembersRequestSuccess;

var getTagMembersRequestFailure = function getTagMembersRequestFailure(reason) {
  return {
    type: _constants.TagMembersType.TAG_MEMBERS_FAILURE,
    payload: reason
  };
};

exports.getTagMembersRequestFailure = getTagMembersRequestFailure;

var getServiceIdentitiesRequest = function getServiceIdentitiesRequest() {
  return {
    type: _constants.ServiceIdentitiesType.SERVICE_IDENTITY_REQUEST
  };
};

exports.getServiceIdentitiesRequest = getServiceIdentitiesRequest;

var resetServiceIdentitiesRequest = function resetServiceIdentitiesRequest() {
  return {
    type: _constants.ServiceIdentitiesType.SERVICE_IDENTITY_RESET
  };
};

exports.resetServiceIdentitiesRequest = resetServiceIdentitiesRequest;

var getServiceIdentitiesRequestLoading = function getServiceIdentitiesRequestLoading() {
  return {
    type: _constants.ServiceIdentitiesType.SERVICE_IDENTITY_LOADING
  };
};

exports.getServiceIdentitiesRequestLoading = getServiceIdentitiesRequestLoading;

var getServiceIdentitiesRequestSuccess = function getServiceIdentitiesRequestSuccess(payload) {
  return {
    type: _constants.ServiceIdentitiesType.SERVICE_IDENTITY_SUCCESS,
    payload: payload
  };
};

exports.getServiceIdentitiesRequestSuccess = getServiceIdentitiesRequestSuccess;

var getServiceIdentitiesRequestFailure = function getServiceIdentitiesRequestFailure(reason) {
  return {
    type: _constants.ServiceIdentitiesType.SERVICE_IDENTITY_FAILURE,
    payload: reason
  };
};

exports.getServiceIdentitiesRequestFailure = getServiceIdentitiesRequestFailure;

var getTokensRequest = function getTokensRequest() {
  return {
    type: _constants.TokensType.TOKENS_REQUEST
  };
};

exports.getTokensRequest = getTokensRequest;

var resetTokensRequest = function resetTokensRequest() {
  return {
    type: _constants.TokensType.TOKENS_RESET
  };
};

exports.resetTokensRequest = resetTokensRequest;

var getTokensRequestLoading = function getTokensRequestLoading() {
  return {
    type: _constants.TokensType.TOKENS_LOADING
  };
};

exports.getTokensRequestLoading = getTokensRequestLoading;

var getTokensRequestSuccess = function getTokensRequestSuccess(payload) {
  return {
    type: _constants.TokensType.TOKENS_SUCCESS,
    payload: payload
  };
};

exports.getTokensRequestSuccess = getTokensRequestSuccess;

var getTokensRequestFailure = function getTokensRequestFailure(reason) {
  return {
    type: _constants.TokensType.TOKENS_FAILURE,
    payload: reason
  };
};

exports.getTokensRequestFailure = getTokensRequestFailure;